export default "__VITE_ASSET__C6a6CDSk__"